import React from "react";
import { EventNote } from "@mui/icons-material";
import { sprintCeremonies, sprintTypes } from "../../../../data/workspaceData";
import { SectionHeader } from "../../common/WorkspaceChrome";

export function SprintsView() {
  return (
    <>
      <section className="split-layout">
        <div className="panel">
        <SectionHeader
          eyebrow="Sprints"
          title="Sprint types for product, client, sales, training, and hiring"
          text="A company can run classic product sprints or adapt the same system for delivery, BDE work, hiring, and training batches."
        />
        <div className="sprint-list">
          {sprintTypes.map((sprint) => (
            <article key={sprint.name}>
              <div>
                <strong>{sprint.name}</strong>
                <span>{sprint.cadence}</span>
              </div>
              <p>{sprint.purpose}</p>
            </article>
          ))}
        </div>
        </div>
        <div className="panel">
        <SectionHeader
          eyebrow="Ceremonies"
          title="Planning, standups, reviews, retrospectives, and release checks"
          text="Meetings produce action items, notes, summaries, linked tasks, and follow-up emails."
        />
        <div className="ceremony-list">
          {sprintCeremonies.map((ceremony) => (
            <article key={ceremony.name}>
              <EventNote fontSize="small" />
              <div>
                <strong>{ceremony.name}</strong>
                <p>{ceremony.output}</p>
              </div>
            </article>
          ))}
        </div>
        </div>
      </section>
    </>
  );
}
